<template>
  <div class="controls__container--lower layout/wrapper">
    <div
      aria-hidden="true"
      class="overlay__credit"
      data-overlay-prevent-close
      >
      <span
        data-overlay-credit
        class="
          $color/white
          $typography/baseline:body
          $typography/size:medium
          $typography/weight:regular
          typography
        "
        style="padding: 0.5rem 0.25rem"
        v-html="imageCredit"
      />
    </div>
    <CarouselNav
      gtm="carousel overlay"
      :currentIndex="currentIndex"
      :itemCount="itemCount"
      @next="$emit('next')"
      @previous="$emit('previous')"
    />
  </div>
</template>

<script>
import CarouselNav from "../../collection/carousel/carousel-nav.vue";

export default {
  components: { CarouselNav },
  props: {
    currentIndex: { type: Number, required: true },
    itemCount: { type: Number, required: true },
    imageCredit: { type: String, required: true }
  }
}
</script>
